import { motion } from 'motion/react';
import { canAccessStories } from '../../lib/stories.js';
import { fadeIn, staggerChild, staggerContainer, tapBounce, tapScale } from '../../lib/motionPresets.js';

export function ModePicker({theme, tracker, onPick, onDash, onSettings, onStories}) {
  const lv = tracker.currentLevel;
  const tc = theme.color;
  const modes = [
    {id:'phonics',emoji:'🔤',name:lv>=11?'Word Power':'Sound It Out',desc:'Phonics Practice'},
    {id:'sight',emoji:'👁️',name:lv>=11?'Vocab Builder':'Sight Words',desc:'Vocabulary Building'},
    {id:'stories',emoji:'📖',name:lv>=9?'Read & Analyze':'Read & Answer',desc:'Reading Comprehension'},
    {id:'bubbles',emoji:'🫧',name:'Bubble Pop',desc:'Word Recognition',locked:!tracker.bubbleUnlocked},
  ];
  const showStories = canAccessStories();

  return (
    <motion.div {...fadeIn} className="px-6 py-6">
      <div className="mb-1 text-center font-finley-display text-3xl text-finley-primary">Extra Practice</div>
      <div className="mb-4 text-center text-sm text-finley-text-light">Choose any activity for some extra time with your child.</div>
      <motion.div variants={staggerContainer} initial="initial" animate="animate" className="mb-9 grid grid-cols-2 gap-4">
        {modes.map(m => (
          <motion.button key={m.id} variants={staggerChild} {...(!m.locked ? tapBounce : {})} onClick={() => !m.locked && onPick(m.id)}
            onKeyDown={e => { if ((e.key==='Enter'||e.key===' ')&&!m.locked) { e.preventDefault(); onPick(m.id); } }}
            disabled={m.locked}
            className={`relative rounded-finley-xl px-5 py-6 text-center shadow-finley-md ${m.locked ? 'border border-finley-text-muted/20 bg-finley-bg-card opacity-60' : 'border border-transparent'}`}
            style={!m.locked ? { background: `linear-gradient(135deg, ${tc}cc, ${tc}88)`, boxShadow: `0 8px 24px ${tc}33` } : undefined}
          >
            {m.id === 'stories' && !m.locked && (
              <span className="absolute right-3 top-3 rounded-finley-full bg-finley-gold px-2 py-1 text-[10px] font-semibold text-finley-text shadow-finley-sm">
                Finley's Pick
              </span>
            )}
            <div className="mb-2 text-4xl">{m.emoji}</div>
            <div className={`mb-1 font-finley-display text-xl ${m.locked ? 'text-finley-text-light' : 'text-white'}`}>{m.name}</div>
            <div className={`text-sm ${m.locked ? 'text-finley-text-light' : 'text-white/85'}`}>{m.locked?'Finish a round!':m.desc}</div>
          </motion.button>
        ))}
      </motion.div>
      {showStories && (
        <motion.button {...tapBounce} onClick={onStories} className="mb-4 flex min-h-[56px] w-full items-center gap-3 rounded-finley-xl px-5 py-4 text-left shadow-finley-lg" style={{ background: 'linear-gradient(135deg,#0D0221,#1A0A3E)' }}>
          <span className="text-3xl">🌙</span>
          <div className="flex-1">
            <div className="font-finley-display text-lg text-finley-text-on-dark">Bedtime Story Library</div>
            <div className="text-sm text-white/70">Personalized stories just for you</div>
          </div>
          <span className="text-lg text-white/50">›</span>
        </motion.button>
      )}
      <motion.button
        {...tapScale}
        onClick={onDash || onSettings}
        className="min-h-[48px] w-full rounded-finley-lg border-2 border-finley-text-muted/20 bg-finley-bg-card px-4 py-3 text-sm text-finley-text-light shadow-finley-sm"
      >
        ← Back to Dashboard
      </motion.button>
    </motion.div>
  );
}
